import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
import times from 'lodash/times';
const Loading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="grid gap-3" data-testid="business-owners-loading">{times(2).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Loading;
function _temp(value) {
  return <div key={value} className="flex flex-col flex-wrap justify-between"><div className="flex flex-col gap-1"><Shimmer height="20px" width="117px" /><Shimmer height="16px" width="388px" /></div><div><Shimmer height="20px" width="105" /></div></div>;
}